import { SwaggerAPI } from "@/api/hunger.api";
import { MgtGroupDto } from "@/api/swagger";
import { NOOP } from "@/constant/constant";
import React, { createContext, useContext, useEffect, useMemo } from "react";
import { useAsyncFn } from "react-use";

type UserProfileContextStore = {
  email: string;
  name: string;
  group: MgtGroupDto | null;
  getCurrentGroupUser: () => void;
};

const defaultValue: UserProfileContextStore = {
  email: "",
  name: "",
  group: null,
  getCurrentGroupUser: NOOP,
};

export const userProfileContext =
  createContext<UserProfileContextStore>(defaultValue);

export const useUserProfileContext = () => useContext(userProfileContext);

export const UserProfileContextProvider: React.FC = ({ children }) => {
  const [{ value }, getCurrentGroupUser] = useAsyncFn(async () => {
    const { data } = await SwaggerAPI.getCurrentGroupUser();
    return data;
  }, []);

  const userProfile = useMemo(() => {
    return value ?? { email: "", name: "", group: null };
  }, [value]);

  useEffect(() => {
    getCurrentGroupUser();
  }, [getCurrentGroupUser]);

  return (
    <userProfileContext.Provider
      value={{
        ...userProfile,
        getCurrentGroupUser,
      }}
    >
      {children}
    </userProfileContext.Provider>
  );
};
